import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import TablePerencanaanPS from 'app/KinerjaTimPenilaiPSPage/components/TablePerencanaanPS'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import usePerencanaanList from 'app/KinerjaTimPenilaiPSPage/hooks/usePerencanaanList'

import type { PerencanaanFilterState } from 'types/kinerja-tim-penilai-ps'

export default function TimPenilaiDaftarPSDenganFilterPage({
  filter,
  headerTitle,
  headerDescription,
}: {
  filter: PerencanaanFilterState
  headerTitle: string
  headerDescription: string
}) {
  const { basePath } = useBasePath()
  const { data, isLoading } = usePerencanaanList({
    filter,
  })

  return (
    <div className="py-6 px-24 max-w-7xl m-auto">
      <Header title={headerTitle} className="mt-6" />
      <div className="bg-white mt-12 border-gray-30 border rounded">
        <div className="space-y-1 px-8 py-6">
          <Text variant="heading-lg" as="h2">
            {headerDescription}
          </Text>
        </div>

        <TablePerencanaanPS
          basePath={basePath}
          data={data?.data ?? []}
          isLoading={isLoading}
          className="!mt-0"
        />
      </div>
    </div>
  )
}
